import i18n from '@/lang/i18n'
import { ModalUtils } from '@/shared/util/modal-utils'
import { StoreUtils } from '@/shared/util/store-utils'

export class BillingOperationWithConceptsGuard {
    private static _hasTooManyConcepts(numberOfConcepts: number): boolean {
        const threshold = StoreUtils.globalParameters?.billableConceptProcessingReasonableThreshold ?? 0
        return numberOfConcepts > threshold
    }
    private static _confirmSlowOperation(): Promise<boolean> {
        return ModalUtils.showConfirmationModal(
            i18n.tc('billing.modal.slowOperationConfirmation'),
            i18n.tc('billing.modal.slowOperationConfirmation.action.accept'))
    }
    static async run<T>(numberOfConcepts: number, promise: () => Promise<T>): Promise<void> {
        if (BillingOperationWithConceptsGuard._hasTooManyConcepts(numberOfConcepts)) {
            if (await BillingOperationWithConceptsGuard._confirmSlowOperation()) {
                StoreUtils.updateLoading(true)
                try {
                    await promise()
                } finally {
                    StoreUtils.updateLoading(false)
                }
            }
        } else {
            await promise()
        }
    }
}
